export default "__VITE_ASSET__1f444897__"